import React from "react";
import ExtractRichText from "../molecules/ExtractRichText";

const SectionTitle = ({
  title,
  subtitle,
  description,
  titleClassName,
  subtitleClassName,
}) => {
  return (
    <>
      {Boolean(title) && (
        <h2
          data-aos="underlined"
          className={`${titleClassName ?? ""} underlined`}
        >
          {title}
        </h2>
      )}
      {Boolean(subtitle) && (
        <h3 className={`${subtitleClassName ?? ""}`}>{subtitle}</h3>
      )}
      {Boolean(description?.value) && (
        <ExtractRichText richText={description?.value} />
      )}
    </>
  );
};

export default SectionTitle;
